
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage, getData } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';

function Index({dishs, setShowListProduct, goHome}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const { menus: menusCurrent, name: title } = dishs;

    const [showSpecials, setShowSpecials] = useState(false);

     const [showCategories, setshowCategories] = useState(false);
    const [titleCategorie, setIitleCategorie] = useState('');

    const [menusData, setMenusData] = useState([]);
     const [menus, setMenus] = useState(menusCurrent);

    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);


     useEffect(() => {
            getData('menu').then((items) => {
                const data = items.value.data;
                setMenusData(data);
            });
        }, []);

    
    useEffect(() => {
        if (menus) {
           
            
            setIitleCategorie(langEng ? 
                dishs.name
                :    
                translate(i18n.language, dishs.language, dishs.name)
            )
        }
    }, [menus]);
    


    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };


    const Item = ({ data }) => {
        const [image, setImage] = useState(false);
        useEffect(() => {
            fetchImage(`menu-image-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);
                    
                }
            });
        }, []);
        
        return (
           <div onClick={()=>[setShowDetailProduct(true), setDataDish({ dish: data, alldish: menus, currentDish: dishs })]}  style={{
                backgroundColor: 'white', marginBottom: 30, textDecoration: 'none', 
                width: 345,
                 maxHeight: 545,
                margin: '15px 0px',
                textAlign: 'left',
                paddingBottom: 40,
                position: 'relative',
                borderRadius: 30,
                padding: 20,
                boxSizing: "border-box",
                display: 'flex',
                flexDirection: 'column'
            }}>
                <img src={image} style={{ width: 305, height: 265, objectFit: 'cover', borderRadius: 30, }} />
                <br/>
                <h3 style={
                    { color: 'black', textTransform: 'uppercase', fontSize: 22, fontWeight: '900',margin: 0, textAlign: 'center' }
                    }> {langEng ? data.name : translate(i18n.language, data.language, data.name)}</h3>
                
                <div style={{ width: '80%', margin: '0 auto' }}>
                    
                    <p
                        className='shor-text'
                        style={{ fontFamily: "LondrinaSolidLight",fontSize: 15, color: '#6D6D6D', textAlign: 'center', margin: 0,}}>

                        {langEng ? 
                                    `${data.regular_decription.replace(/\\n/g,'\n')}`
                                : 
                                `${translateMenu(
                                    i18n.language, 
                                    data.language, 
                                    data.regular_decription, 
                                    'regular_decription'
                                )}`
                        }
                        
                        
                    </p>
                </div>
                
            </div>
        );
    }

    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showLamp={ false}  goCategories={setshowCategories} showBack={true} showImageTop={false} goHome={goHome} setShowListProduct={setShowListProduct} setShowSpecials={setShowSpecials}>
                
                
                <div >
                    <div style={{
                       
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            padding: '0px 10px 100px 10px',
                            height: 680,
                            overflow: 'scroll',
                            
                    }}>
                        {dishs.id == 249 &&
                <div style={{
                    backgroundColor: '#E53935',
                    borderRadius: '15px',
                    textAlign: 'center',
                    color: 'white',
                    fontFamily: 'Arial, sans-serif',
                        fontWeight: 'bold',
                    
                }}>
                    {/* Primera línea - Choose 2 Sides */}
                    <div style={{
                        fontSize: '14px',
                            marginBottom: '5px',
                            padding: '5px'
                    }}>
                        <span style={{ color: '#FFFF00' }}>Choose 2 Sides: </span>
                        <span style={{ color: 'white' }}>Sweet Plantain, Green Plantain, French Fries, Creole Potato, Small Corn Cake, Fried Cassava, Green Salad, White Rice, Beans, Steamed Potato and Steamed Vegetables.</span>
                    </div>
                    
                    {/* Segunda línea - Escoge 2 Acompañantes */}
                        <div style={{
                        marginTop: '10px',
                            fontSize: '14px',
                                                    padding: '5px',
                            background: 'white',
                         borderRadius: '0px 0px 15px 15px',
                    }}>
                        <span style={{ color: '#E53935' }}>Escoge 2 Acompañantes: </span>
                        <span style={{ color: 'black' }}>Maduros, Tostones, Papas a Francesa, Papa Criolla, Arepita, Yuca Frita, Ensalada Verde, Arroz, Frijoles, Papa Cocida Y Vegetales al Vapor.</span>
                    </div>
                </div>  
                        }
                        {dishs.id == 203 &&
                <div style={{
                    backgroundColor: '#E53935',
                    borderRadius: '15px',
                    textAlign: 'center',
                    color: 'white',
                    fontFamily: 'Arial, sans-serif',
                        fontWeight: 'bold',
                    
                }}>
                    {/* Primera línea - Choose 2 Sides */}
                    <div style={{
                        fontSize: '14px',
                            marginBottom: '5px',
                            padding: '7px'
                    }}>
                        <span style={{ color: '#FFFF00' }}>Las Ensaladas Vienen Con: </span>
                        <span style={{ color: 'white' }}>Lechuga, Tomate, Pepino, Cebolla, Crutones Sazonados, Queso Y Aguacate.</span>
                    </div>
                    
                    {/* Segunda línea - Escoge 2 Acompañantes */}
                        <div style={{
                        marginTop: '10px',
                            fontSize: '14px',
                                                    padding: '7px',
                            background: 'white',
                         borderRadius: '0px 0px 15px 15px',
                    }}>
                        <span style={{ color: '#E53935' }}>All Salads Come With: </span>
                        <span style={{ color: 'black' }}>Lettuce, Tomato, Cucumber, Onion, Seasoned Croutons,
Cheese and Avocado</span>
                    </div>
                </div>  
               }
                            {menus.map((item, key) => (
                                <Item data={ item }  key={key} />
                            ))}
                    </div>   
                    
      

                
                
                </div>
                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}

                
                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={goHome} />}
                
            </LayoutContent>
        </div>
    );
}
export default Index;